import { Component, inject, OnInit } from '@angular/core';
import { AdminBoilerplateComponent } from "../../../../../core/admin-boilerplate/feature/admin-boilerplate.component";
import { HeadlineComponent } from "../../../../../events/headline/feature/headline.component";
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { selectAdminEvent, selectAdminPermittedEventHosts, selectAllAdminOrganisers } from '../../../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../../../data-services/stores/actions/admin.actions';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventComplete } from '../../../../../data-services/models/events/event-complete.model';
import { EventHostComplete } from '../../../../../data-services/models/event-hosts/event-host-complete.model';
import { AdminService } from '../../../../../data-services/admin.service';
import { EditorModule } from 'primeng/editor';
import { takeWhile, tap } from 'rxjs';
import { formatDate } from '@angular/common';
import { ToggleButton } from 'primeng/togglebutton'
import { ToggleSwitch } from "primeng/toggleswitch";
import { format } from 'path';
import { AuthService } from '../../../../../data-services/auth.service';

@Component({
  selector: 'app-details',
  imports: [CommonModule, AdminBoilerplateComponent, HeadlineComponent, FormsModule, ReactiveFormsModule, EditorModule, ToggleSwitch],
  templateUrl: '../ui/details.component.html'
})
export class AdminEventDetailsComponent implements OnInit{
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  private readonly _service = inject(AdminService);
  private readonly _authService = inject(AuthService)
  isAdmin = this._authService.isAdministrator();
  detailsForm: FormGroup = new FormGroup({
    eventDescription: new FormControl<string>(''),
    promoDescription: new FormControl<string>(''),
    icInvitation: new FormControl<string>(''),
    location: new FormControl<string>(''),
    startDate: new FormControl<Date | undefined>(undefined),
    endDate: new FormControl<Date | undefined>(undefined),
    name: new FormControl<string>(''),
    hostID: new FormControl<number>(0),
    allowBookings: new FormControl<boolean>(false),
    advertised: new FormControl<boolean>(false),
    organiserID: new FormControl<number>(0)
  })

  event$ = this._store.select(selectAdminEvent(this._route.snapshot.params["id"])).pipe(
    takeWhile(x => !x, true),
    tap(lrpEvent => {
      if (lrpEvent){
        this.detailsForm.setValue({
          name: lrpEvent.name,
          promoDescription: lrpEvent.promoDescription,
          eventDescription: lrpEvent.fullDescription,
          icInvitation: lrpEvent.icInvitation,
          location: lrpEvent.location,
          startDate: formatDate(lrpEvent.eventStart, 'yyyy-MM-dd', 'en'),
          endDate: formatDate(lrpEvent.eventEnd, 'yyy-MM-dd', 'en'),
          hostID: lrpEvent.eventHost.hostID,
          advertised: lrpEvent.visible,
          allowBookings: lrpEvent.allowBookings,
          organiserID: lrpEvent.organiserID ?? 0
        })
        this.eventHosts$ = this._store.select(selectAdminPermittedEventHosts(lrpEvent.eventHost.eventSystem.systemID))
      }
  }))
  eventHosts$ = this._store.select(selectAdminPermittedEventHosts(0))
  eventHosts?: EventHostComplete[]; 
  organisers$ = this._store.select(selectAllAdminOrganisers)

  
  ngOnInit(): void {
    this._store.dispatch(adminActions.getEvent({ eventRef: this._route.snapshot.params["id"] }));
    this._store.dispatch(adminActions.getEventHosts());
    this._store.dispatch(adminActions.getOrganisers())
  }

  saveDetails(lrpEvent: EventComplete){
    this._store.dispatch(adminActions.updateEvent({ update: {
      changes: {
        fullDescription: this.detailsForm.controls['eventDescription'].value,
        icInvitation: this.detailsForm.controls['icInvitation'].value,
        promoDescription: this.detailsForm.controls['promoDescription'].value,
        location: this.detailsForm.controls['location'].value,
        eventStart: this.detailsForm.controls['startDate'].value,
        eventEnd: this.detailsForm.controls['endDate'].value,
        name: this.detailsForm.controls['name'].value,
        allowBookings: this.detailsForm.controls['allowBookings'].value,
        visible: this.detailsForm.controls['advertised'].value,
        eventHost: {
          ... lrpEvent.eventHost,
          hostID: this.detailsForm.controls['hostID'].value
        },
        organiserID: this.detailsForm.controls['organiserID'].value
      },
      id: lrpEvent.eventID
    } }))
  }
}
